import { indexData } from '@/mocks/home';

const colorMap: Record<string, { bg: string; iconBg: string; text: string }> = {
  primary: {
    bg: 'bg-primary-50 hover:bg-primary-100',
    iconBg: 'bg-primary-100',
    text: 'text-primary-600',
  },
  accent: {
    bg: 'bg-accent-50 hover:bg-accent-100',
    iconBg: 'bg-accent-100',
    text: 'text-accent-600',
  },
  secondary: {
    bg: 'bg-secondary-50 hover:bg-secondary-100',
    iconBg: 'bg-secondary-100',
    text: 'text-secondary-600',
  },
};

export default function SectionIndex() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            热门专题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            一站式浏览最受欢迎的吃瓜频道，快速找到你感兴趣的八卦专题
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexData.map((item) => {
            const c = colorMap[item.color] || colorMap.primary;
            return (
              <a
                key={item.id}
                href={`#${item.color === 'primary' ? 'ranking' : item.color === 'accent' ? 'carousel' : 'comments'}`}
                onClick={(e) => {
                  e.preventDefault();
                  const href = item.color === 'primary' ? '#ranking' : item.color === 'accent' ? '#carousel' : '#comments';
                  const el = document.querySelector(href);
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className={`${c.bg} rounded-xl p-4 md:p-5 transition-all duration-200 cursor-pointer group`}
              >
                <div className={`${c.iconBg} w-10 h-10 md:w-11 md:h-11 rounded-lg flex items-center justify-center mb-3 group-hover:scale-110 transition-transform`}>
                  <i className={`${item.icon} ${c.text} text-lg md:text-xl`}></i>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 mb-2">
                  {item.desc}
                </p>
                {item.count && (
                  <span className={`text-xs md:text-sm font-bold ${c.text}`}>
                    {item.count}
                  </span>
                )}
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}